export default __webpack_public_path__ + "static/3-41fc88b33b8dfc2c1eed3d3c0ef4f3d1.jpeg";